import { render, staticRenderFns } from "./SalesList.vue?vue&type=template&id=69b40f6e&scoped=true&"
import script from "./SalesList.vue?vue&type=script&lang=js&"
export * from "./SalesList.vue?vue&type=script&lang=js&"
import style0 from "./SalesList.vue?vue&type=style&index=0&id=69b40f6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b40f6e",
  null
  
)

export default component.exports